import Login from '../pages/Login'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

export default function SignRoutes(): JSX.Element {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Login />} />
        <Route path='*' element={<Login />} />
      </Routes>
    </BrowserRouter>
  )
}